import Layout from "./layout";

const App = () => (
  <>
    <Layout />
  </>
);

export default App;
